import './ProviderDataStyle.css';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function ERA5() {
  return (
    <>
      <div className="dialogWarning">
        MIKE Data Link carries out comprehensive quality control checks on all third-party datasets.
        However, errors and inconsistencies inherited from these datasets (for example, missing
        values) may appear as errors in extracted data. If you encounter incorrect values such as
        NaN or erroneous zero values in extracted boundary conditions, initial conditions, or
        forcings output files, please contact{' '}
        <a href="mailto:mike@dhigroup.com">mike@dhigroup.com.</a>
      </div>
      <div className="dialogSummary">
        The data set ECMWF Reanalysis v5 (ERA5) includes a selection of global-scale meteorological
        data variables. ERA5 is produced by the European Center for Medium-Range Weather Forecasts
        (ECMWF) and is a fully coupled model representing the interaction between the Earth's
        oceans, land and atmosphere. The data set is developed for and distributed under the
        Copernicus Climate Change Service (C3S).
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>ECMWF Reanalysis v5 (ERA5)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Meteorological Parameters</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>ECMWF Reanalysis v5 (ERA5), Selected Hourly Timeseries Products </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>European Center for Medium-Range Weather Forecasts (ECMWF)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Product type</TableCell>
            <TableCell>Grid</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Wind, Wave, Hydrodynamic, Offshore and Marine projects</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>References</TableCell>
            <TableCell>
              <a
                href="https://confluence.ecmwf.int/display/CKB/ERA5%3A+data+documentation#heading-TheIFSanddataassimilation"
                target="_blank"
                rel="noopener noreferrer">
                ECWMF ERA5 documentation
              </a>
              <br />
              <a
                href="https://cds.climate.copernicus.eu/cdsapp#!/dataset/reanalysis-era5-single-levels?tab=overview"
                target="_blank"
                rel="noopener noreferrer">
                ERA5 dataset description
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>
              Global: <br />
              Longitude: -180°W to 180°E <br /> Latitude: -90°S to 90°N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>Data variables resolutions (quadratic grid cells): 0.25 degree</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>
              Data Link coverage: 1/1-1979 -&gt; Present (change to end date if daily updates to
              present not yet supported)
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>1 hour</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>Wind velocity components (U & V) at 10m [m/s]</TableCell>            
          </TableRow>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>            
            <TableCell>Air Pressure at Mean Sea Level [hPa]</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Credits
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Cited Authors and Originators</TableCell>
            <TableCell>
              European Center for Medium-Range Weather Forecasts (ECMWF), Reading, United Kingdom,
              ECMWF, Shinfield Park, RG2 9AX
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>License</TableCell>
            <TableCell>
              <a
                href="https://confluence.ecmwf.int/display/CKB/ERA5%3A+data+documentation#heading-TheIFSanddataassimilation"
                target="_blank"
                rel="noopener noreferrer">
                Link
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
